<mat-form-field class="w-100 dense-2" [appearance]="appearance">
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    [matDatepickerFilter]="dateFilter"
    [matDatepicker]="picker"
    [formControl]="formControlRef()"
    [required]="required()"
    [min]="min()"
    [max]="max()"
  />
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
